import { render, staticRenderFns } from "./template-exchange.vue?vue&type=template&id=0a8f35ba&scoped=true&lang=pug&"
import script from "./template-exchange.vue?vue&type=script&lang=js&"
export * from "./template-exchange.vue?vue&type=script&lang=js&"
import style0 from "./template-exchange.vue?vue&type=style&index=0&id=0a8f35ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8f35ba",
  null
  
)

export default component.exports